<template>
  <el-row :gutter="20" :class="$style.h100">
    <el-col :span="12" :class="$style.h100">
      <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
        <div class="title-h4 mr-r10 vertical-center-box">{{userText}}</div>
        <w-header-search-button @click="userShowSearchTool = !userShowSearchTool" style="height:28px" />
      </el-row>
      <el-row :class="$style.h100">
        <el-table-wrapper v-loading="isLoading" :data="userList" :columns="tableColumns" :column-default="columnDefault" ref="userTable" :pagination="true"
        :show-search-tool="userShowSearchTool" :show-custom-header="true" @select="checkUserList" @select-all="checkAllUserList" @condition-change="loadData"
        remote :total="total" :style="fitHeight ? { height: '100%' } : null" :fit-height="fitHeight"/>
      </el-row>
    </el-col>
    <el-col :span="12" :class="$style.h100">
      <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
        <div class="title-h4 mr-r10 vertical-center-box">{{authUserText}}</div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" @click="releaseAuthUserList" :disabled="checkedAuthUserList.length === 0">해제</el-button>
          <w-header-search-button @click="authUserShowSearchTool = !authUserShowSearchTool" style="height:28px" />
        </div>
      </el-row>
      <el-row :class="$style.h100">
        <el-table-wrapper :data="checkedUserList" :columns="tableColumns" :column-default="columnDefault" ref="authUserTable"
          :pagination="true" :show-search-tool="authUserShowSearchTool" :show-custom-header="true" @selection-change="checkAuthUserList"
          :style="fitHeight ? { height: '100%' } : null" :fit-height="fitHeight"/>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { isNil, isEmpty, cloneDeep } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import UserSettingAPI from '@/api/settings/user/user-setting';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WUserAuthSetting',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'regist',
    },
    objIds: {
      type: Array,
      default: () => [],
    },
    fitHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      columnDefault,
      userShowSearchTool: false,
      authUserShowSearchTool: false,
      userList: [],
      total: 0,
      checkedUserList: [],
      checkedAuthUserList: [],
      tableColumns: [
        {
          type: 'selection',
          width: 55,
        },
        {
          prop: 'managerId',
          label: 'ID',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'managerName',
          label: '이름',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'managerType',
          label: '역할',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'association',
          label: '소속',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'department',
          label: '부서',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'grade',
          label: '직급',
          searchable: true,
          formatter: defaultFormatter,
        },
      ],
    };
  },
  computed: {
    userText() {
      if (this.type === 'ADD') {
        return '사용자 목록';
      }
      return '권한이 할당된 사용자 목록';
    },
    authUserText() {
      if (this.type === 'ADD') {
        return '권한을 할당할 사용자 목록';
      }
      return '권한을 해제할 사용자 목록';
    },
  },
  watch: {
    active: {
      handler(value) {
        if (value) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      this.isLoading = true;
      const tableParams = this.$refs.userTable.getParameter();
      const params = {
        exceptManagerTypes: ['ADMIN'],
        activeStatus: 'Y',
        ...tableParams,
      };
      if (this.type === 'DELETE') {
        params.objIds = this.objIds;
      }
      UserSettingAPI.getUserList(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.userList = result.data;
          this.total = result.total;
        } else {
          this.userList = [];
          this.total = 0;
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자 정보', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자 정보', false));
      }).finally(() => {
        this.isLoading = false;
      });
    },
    initData() {
      this.checkedUserList = [];
    },
    checkUserList(selection, row) {
      const checkedUser = this.checkedUserList.find((user) => (user.managerId === row.managerId));
      if (!isNil(checkedUser)) {
        this.checkedUserList.splice(this.checkedUserList.indexOf(checkedUser), 1);
      } else {
        this.checkedUserList.push(row);
      }
    },
    checkAllUserList(selection) {
      const userList = this.userList;
      userList.forEach((row) => {
        const checkedUser = this.checkedUserList.find((user) => (user.managerId === row.managerId));
        if (selection.length > 0) {
          if (isNil(checkedUser)) {
            this.checkedUserList.push(row);
          }
        } else if (selection <= 0) {
          if (!isNil(checkedUser)) {
            this.checkedUserList.splice(this.checkedUserList.indexOf(checkedUser), 1);
          }
        }
      });
    },
    checkAuthUserList(selection) {
      this.checkedAuthUserList = cloneDeep(selection);
    },
    releaseAuthUserList() {
      const checkedAuthUserList = this.checkedAuthUserList;
      const tempCheckedUserList = cloneDeep(this.checkedUserList);
      checkedAuthUserList.forEach((row) => {
        const releaseUser = tempCheckedUserList.find((user) => user.managerId === row.managerId);
        tempCheckedUserList.splice(tempCheckedUserList.indexOf(releaseUser), 1);
      });
      checkedAuthUserList.forEach((row) => {
        this.checkedUserList.splice(this.checkedUserList.indexOf(row), 1);
      });
      this.$nextTick(() => {
        this.clearSelection();
        this.toggleRowSelection(tempCheckedUserList);
      });
    },
    toggleRowSelection(rows) {
      rows.forEach((row) => {
        const user = this.userList.find((item) => item.managerId === row.managerId);
        this.$refs.userTable.getTable().toggleRowSelection(user);
      });
    },
    clearSelection() {
      this.$refs.userTable.getTable().clearSelection();
    },
    getManagerIds() {
      const managerIds = [];
      this.checkedUserList.forEach((row) => {
        managerIds.push(row.managerId);
      });
      return managerIds;
    },
  },
};
</script>

<style module>
.h100 {
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/popup/DeviceAuthSettingPopup/components/UserAuthSetting.vue